module.exports = __webpack_public_path__ + "assets/load.svg?187b066da40b255c29cddd0d7d847641";